.ux-iws-icon-label-toggle {
    display: flex;
    align-items: center;

    ux-icon[name="checkmark"] {
        color: $color-green;
        font-size: 18px;
        margin-right: 10px;
    }

    ux-icon[name="cross"] {
        color: $color-gray-40;
        font-size: 15px;
        margin-right: 10px;
    }

    &__tooltip {
        display: flex;
        align-items: center;
        margin-left: 15px;

        p {
            margin: 0;
        }
    }

    &__label {
        color: $color-gray-40;
    }

    &--active {
        .ux-iws-icon-label-toggle__label {
            color: $color-black-dark;
        }
    }
}
